/* global ym */
<template lang="pug">
  div
    label.standart_label(for="product") Продукт
    v-select.standart_input(
      v-model="product_value"
      :items="products"
      label="Выберите продукт"
      single-line
      dense
      outlined
      name="product"
      filled
      height="22px"
      background-color="#fff"
      color="#D4D4D4"
      :error="product_is_empty"
      @change="ProductChanger"
    )
    label.standart_label(for="slider") Продолжительность РК (дней)
    v-select.standart_input(
      label="31"
      name="slider"
      single-line
      outlined
      dense
      filled
      height="22px"
      background-color="#fff"
      color="#D4D4D4"
      disabled
      v-model="the_month"
      v-if="product_value == product_smart_trp_id"
    )
    v-text-field.standart_input(
      v-model="slider"
      label="Продолжительность РК"
      single-line
      dense
      outlined
      name="slider"
      filled
      height="22px"
      background-color="#fff"
      color="#165FA8"
      type="number"
      min="1"
      max="31"
      @change="ChangeRK"
      item-color="#165FA8"
      v-else
    )

    label.standart_label(
      for="platform"
      v-if="(product_value != product_video_network_web_id && \
             product_value != product_smart_tv_id && \
             product_value != product_videonetwork_smart_tv_id && \
             product_value != product_banner_id && \
             product_value != product_banner_premium_id && \
             product_value != product_banner_reach_fullscreen_id && \
             product_value != product_smart_trp_id && \
             product_value != product_cinema_online_id)") Платформа
    v-select.standart_input(
      v-model="platform_values"
      :items="platforms"
      label="Платформа"
      name="platform"
      multiple
      single-line
      outlined
      dense
      filled
      height="22px"
      background-color="#fff"
      color="#D4D4D4"
      chips
      :error="platform_is_empty"
      @change="PlatformChanger"
      v-if="product_value != product_video_network_web_id && \
            product_value != product_smart_tv_id && \
            product_value != product_videonetwork_smart_tv_id && \
            product_value != product_banner_id && \
            product_value != product_banner_premium_id && \
            product_value != product_banner_reach_fullscreen_id && \
            product_value != product_smart_trp_id && \
            product_value != product_online_tv_id && \
            product_value != product_cinema_online_id"
    )
    v-select.standart_input(
      v-model="platform_values"
      :items="platforms_online_tv"
      label="Платформа"
      name="platform"
      multiple
      single-line
      outlined
      dense
      filled
      height="22px"
      background-color="#fff"
      color="#D4D4D4"
      chips
      :error="platform_is_empty"
      @change="PlatformChanger"
      v-else-if="product_value == product_online_tv_id || product_value == product_cinema_online_id"
    )

    label.standart_label(for="frequency_period_value") Период частоты
    v-select.standart_input(
      v-model="frequency_period_value"
      :items="(product_value == product_banner_id || product_value == product_banner_premium_id || product_value == product_banner_reach_fullscreen_id) ? frequency_period_banner : \
              product_value == product_smart_trp_id ? frequency_period_trp : \
              product_value == product_smart_tv_id ? frequency_period_smart_tv : \
              frequency_period"
      label="Период частоты"
      name="frequency_period_value"
      single-line
      outlined
      dense
      filled
      height="22px"
      background-color="#fff"
      color="#D4D4D4"
      :error="period_is_empty"
      @change="PeriodChanger"
    )

    div(v-if="product_value != product_smart_trp_id")
      label.standart_label(for="frequency") Настройка частоты
      v-text-field.standart_input(
        v-model="frequency"
        label="Частота"
        single-line
        dense
        outlined
        name="frequency"
        filled
        height="22px"
        background-color="#fff"
        color="#D4D4D4"
        type="number"
        min="1"
        :max="max_frequency"
        @change="ChangeFrequency"
      )
    
    div(v-if="product_value === product_smart_trp_id && frequency_period_value")
      label.standart_label(for="frequency_trp") Настройка частоты
      v-text-field.standart_input(
        v-model="frequency_trp"
        label="Частота"
        single-line
        dense
        outlined
        name="frequency_trp"
        filled
        height="22px"
        background-color="#fff"
        color="#D4D4D4"
        type="number"
        :min="min_frequency_trp"
        :max="max_frequency_trp"
        @change="ChangeFrequencyTrp"
      )

    .range_slider_wrapper.mt-2(v-if="product_value == product_smart_trp_id")
      label.standart_label(for="age_value") Возраст {{ current_age_trp_title }}
      v-switch.v-switch(
        v-model="is_ages_trp_available"
        @change="AgeSwitchTrpChanger"
      )
      .v-range-slider_inwrap
        v-range-slider(
          :tick-labels="ages_trp_titles"
          min="0"
          max=7
          ticks="always"
          v-model="age_value_trp_range"
          tick-size=3
          :disabled="!is_ages_trp_available"
          @change="AgeRangeTrpChanger"
        )
    .range_slider_wrapper.mt-2(v-else)
      label.standart_label(for="age_value") Возраст {{ current_age_title }}
      v-switch.v-switch(
        v-model="is_ages_available"
        @change="AgeSwitchChanger"
        :disabled="is_choose_disabled"
      )
      .v-range-slider_inwrap
        v-range-slider(
          :tick-labels="ages_titles"
          min="0"
          max=6
          ticks="always"
          v-model="age_value_range"
          tick-size=3
          :disabled="!is_ages_available || is_choose_disabled"
          @change="AgeRangeChanger"
        )

    label.standart_label(for="sex_value") Пол
    v-select.standart_input(
      v-model="sex_value"
      :items="sexes"
      label="Пол"
      name="sex_value"
      single-line
      outlined
      :disabled="is_choose_disabled"
      dense
      filled
      height="22px"
      background-color="#fff"
      color="#D4D4D4"
      :error="sex_is_empty"
      @change="SexChanger"
    )
    div.pos_r(
      v-tippy="{ placement: 'right', theme: 'light-border' }"
      v-if="product_value == product_flex_id"
      content="При активном чекбоксе из учёта исключаются рекламные сети оптимизаторов (Ivi dis., Adcamp, Stream, Adspector, Plazkart и др.)"
    )
      v-checkbox.mt-2.govnosite_checkbox(
        v-model="is_not_govnosites"
        @change="GovnositesChanger"
        v-if="product_value == product_flex_id"
        label="Учитывать только Top-Logo"
      )
      img.icon.icon_hint(src="~@/assets/images/hint.svg")

    label.standart_label(for="interests_value" v-if="product_value == product_banner_id || product_value == product_banner_reach_fullscreen_id || product_value == product_banner_premium_id") Интересы
    v-autocomplete.standart_input(
      v-model="interests_value"
      :items="interests"
      label="Интересы"
      name="interests_value"
      single-line
      outlined
      dense
      filled
      multiple
      chips
      height="22px"
      background-color="#fff"
      color="#D4D4D4"
      :error="interests_is_empty"
      v-if="product_value == product_banner_id || product_value == product_banner_reach_fullscreen_id || product_value == product_banner_premium_id"
      @change="InterestsChanger"
      ref="interestsSelect"
    )
      template(v-slot:selection="{ item, index }")
        v-chip(v-if="index < 2" small) {{ item.text }}
        span(v-if="index === 2" class="grey--text text-caption ml-1") (+{{ interests_value.length - 2 }})
      template(v-slot:prepend-item)
        v-list-item(@click="toggleSelectAllInterests")
          v-list-item-action
            v-icon(:color="selectAllIconColor") {{ selectAllIcon }}
          v-list-item-content
            v-list-item-title Выбрать все

      template(v-slot:append-item)
        .interests_actions
          v-btn.interests_btn(text small @click="resetInterests") Сбросить
          v-btn.interests_btn.interests_btn_ok(text small color="primary" @click="closeInterests") ОК

    .button.mb-3.mt-3#calculate_button(
      @click="sendCalculateRequest"
      v-if="product_value && \
            isPlatformValues() && \
            (product_value == product_smart_trp_id ? \
            (frequency_period_value && frequency_period_value != 'month') : frequency_period_value) && \
            age_value && sex_value && slider && \
            ((is_accumulated === false || is_accumulated === true) || product_value == product_banner_id || product_value == product_banner_premium_id || product_value == product_banner_reach_fullscreen_id)"
    ) 
      img.icon(src="~@/assets/images/recalculation.svg")
      span.text Рассчитать
    .button.mb-3.mt-3#calculate_button_unactive(
      v-else
      @click="FakeSender"
    )
      img.icon(src="~@/assets/images/recalculation.svg")
      span.text Рассчитать

    .button.mb-5#print_button(
      v-if="regions.length"
      @click="sendXlsxRequest"
    )
      img.icon(src="~@/assets/images/export.svg")
      span.text Скачать в Excel

    div(v-if="product_value == product_smart_trp_id && customer_audience")
      p.customer_audience <span>*</span> Вам подходит Баинговая аудитория: {{ customer_audience }}

    .bottom_notifications_wrap
      Notification(
        id="inventory_notify"
        ref="notify"
        text="Рассчитан максимально доступный объем для выделенных строк."
        title="Внимание!"
      )

      Notification(
        id="month_notify"
        ref="notify_month"
        text="Указанный объём инвентаря действителен только на момент расчёта и учитывает текущие бронирования."
        title="Внимание!"
      )

</template>

<script>

import { sendCalculateRequest, sendXlsxRequest } from "../api/index";
import { isArrayEqual } from "../service/service";
import { commonMixin } from "../shared/mixins";
import Notification from "./Notification";

export default {
  name: 'CalcForm',
  components: {
    Notification,
  },
  props: {
    products: Array,
    ages: Array,
    current_month: String,
    max_month: String,
    alternative_ages: Array,
    ages_old_products: Array,
    sexes: Array,
    interests: Array,
    platforms_list: Array,
    platforms_mapper: Array
  },
  data () {
    return {
      date_month_value: null,
      modal: false,
      products_list_by_id: ['VIDEO_NETWORK_ONLINE_TV', 'VIDEO_NETWORK_FLEX', 'VIDEO_NETWORK_INTERACTIVE', 'VIDEO_NETWORK_CINEMA', 'BANNER_NETWORK_REACH', 'VIDEO_NETWORK_INTERACTIVE_SMART_TV', 'VIDEO_NETWORK_FLEX_NO_TOP_LOGO', 'VIDEO_NETWORK_SMART_TRP', 'BANNER_NETWORK_PREMIUM', 'BANNER_NETWORK_REACH_FULLSCREEN', 'VIDEO_NETWORK_CINEMA_ONLINE', 'VIDEO_NETWORK_SMART_TV'],
      product_is_empty: false,
      platform_is_empty: false,
      period_is_empty: false,
      age_is_empty: false,
      sex_is_empty: false,
      accum_is_empty: false,
      interests_is_empty: false,
      rk_length_is_empty: false,
      max_frequency: 10,
      raw_data: [],
      the_month: 31,

      is_ages_available: true,
      age_value_range: [0, 6],
      ages_titles: ['0', '18', '24', '34', '44', '54', '∞'],
      ages_start_values: ["0", "18", "25", "35", "45", "55"],
      ages_end_values: ["0", "18", "24", "34", "44", "54", "55+"],

      is_ages_trp_available: true,
      age_value_trp_range: [0, 7],
      ages_trp_titles: ['4', '18', '24', '34', '44', '54', '64', '∞'],
      ages_start_trp_values: ["4", "18", "25", "35", "45", "55", "65"],
      ages_end_trp_values: ["4", "18", "24", "34", "44", "54", "64", "65+"],
      is_choose_disabled: null,
      frequency_trp: 1,
      max_frequency_trp: 10,
      min_frequency_trp: 1,

      platforms: [
        {
          text: "Web",
          value: "web"
        },
        { 
          text: "App",
          value: "app"
        },
        {
          text: "SmartTv",
          value: "smart_tv"
        }
      ],
      platforms_online_tv: [
        { 
          text: "App",
          value: "app"
        },
        {
          text: "SmartTv",
          value: "smart_tv"
        },
        {
          text: "Web",
          value: "web",
          disabled: true
        }
      ],
      frequency_period: [
        {
          text: "За день",
          value: "day"
        },
        {
          text: "За неделю",
          value: "week"
        }
      ],
      frequency_period_day_week_month: [
        {
          text: "За день",
          value: "day"
        },
        {
          text: "За неделю",
          value: "week"
        },
        {
          text: "За месяц",
          value: "month"
        }
      ],
      frequency_period_day_week: [
        {
          text: "За день",
          value: "day"
        },
        {
          text: "За неделю",
          value: "week"
        }
      ],
      frequency_period_day: [
        {
          text: "За день",
          value: "day"
        }
      ],
      frequency_period_banner: [
        {
          text: "За день",
          value: "day"
        },
        {
          text: "За неделю",
          value: "week"
        },
        {
          text: "За месяц",
          value: "month"
        }
      ],
      frequency_period_trp: [
        {
          text: "За день",
          value: "day"
        },
        {
          text: "За неделю",
          value: "week"
        },
      ],
      frequency_period_smart_tv: [
        {
          text: "За день",
          value: "day"
        },
        {
          text: "За неделю",
          value: "week"
        },
      ],
      rk_length_options: [14, 30],
      slider: 7,
      frequency: 2,
      product_value_old: null,
      product_value: null,
      shown_product: null,
      product_online_tv_id: 1,
      product_flex_id: 2,
      product_video_network_web_id: 3,
      product_cinema_id: 4,
      product_cinema_online_id: 11,
      product_banner_id: 5,
      product_smart_tv_id: 6,
      product_flex_sheet_id: 7,
      product_smart_trp_id: 8,
      product_banner_premium_id: 9,
      product_banner_reach_fullscreen_id: 10,
      product_videonetwork_smart_tv_id: 12,
      is_not_govnosites: true,
      frequency_period_value: null,
      platform_values: null,
      interests_value: null,
      sex_value: null,
      age_value_old: [],
      age_value: null,
      actual_age_value: null,
      show_form_value: false,
      reach: 0,
      impressions: 0,
      limit_impressions: 0,
      impressions_ratio: 1,
      regions: [],
      is_accumulated: false,
      flex_choose_disabled: false,
      type_of_data: null,
      accumulate_trafic: [{
          "text": "Не аккумулировать неопределённый трафик",
          "value": false
        },
        {
          "text": "Аккумулировать весь неопределённый трафик",
          "value": true
        }
      ],
      is_open_hideble: false,
      customer_audience: null,
      customer_audiences: {
        "1": ["М 18-64"],
        "2": ["Ж 18-64"],
        "3": ["Все 35+", "Все 4-44", "Все 18-64"]
      }
    }
  },
  computed: {
    current_age_title () {
      if (!this.is_ages_available) {
        return "Без настройки"
      } else {
        return `${this.ages_start_values[this.age_value_range[0]]}-${this.ages_end_values[this.age_value_range[1]]}`
      }
    },
    current_age_trp_title () {
      if (!this.is_ages_trp_available) {
        return "Без настройки"
      } else {
        return `${this.ages_start_trp_values[this.age_value_trp_range[0]]}-\
${this.ages_end_trp_values[this.age_value_trp_range[1]]}`
      }
    },
selectAllIcon () {
  const NOT_DEFINED_ID = 23

  const realInterests = this.interests
    .map(i => i.value)
    .filter(id => id !== NOT_DEFINED_ID)

  const selected = (this.interests_value || []).filter(id => id !== NOT_DEFINED_ID)

  if (selected.length === 0) {
    return 'mdi-checkbox-blank-outline'
  }

  if (selected.length === realInterests.length) {
    return 'mdi-close-box'
  }

  return 'mdi-minus-box'
},
selectAllIconColor () {
  const NOT_DEFINED_ID = 23
  const realInterests = this.interests
    .map(i => i.value)
    .filter(id => id !== NOT_DEFINED_ID)
  const selected = (this.interests_value || []).filter(id => id !== NOT_DEFINED_ID)
  return selected.length === realInterests.length && selected.length > 0
    ? 'primary'
    : ''
}
  },
  mixins: [
    commonMixin  
  ],
  mounted () {
    this.interests_value = [23];
    this.age_value = [15];
    this.date_month_value = this.current_month;
  },
  methods: {
    user_roles_mapper(user_role_id) {
      let user_role = parseInt(user_role_id, 10);
      if ([1, 2, 6, 7, 8, 9, 11, 12, 13, 15, 16, 18, 19, 22, 23, 27, 28].includes(user_role)) {
        // return "2";
        return "Внешние пользователи";
      } else if ([10, 14, 17].includes(user_role)) {
        // return "3";
        return "Внутренние пользователи (продукт)";
      } else if ([3, 21].includes(user_role)) {
        // return "4";
        return "Клиентский отдел DA";
      } else if (user_role == 5) {
        // return "1";
        return "Админы";
      }
      return "0"
    },
    isPlatformValues () {
      if (this.platform_values) {
        if (this.platform_values.length) {
          return true
        }
      }
    },
    resetInterests () {
      this.interests_value = [23]
    },
    closeInterests () {
      this.$refs.interestsSelect.blur()
    },
    toggleSelectAllInterests () {
      this.$nextTick(() => {
        const NOT_DEFINED_ID = 23
        const realInterests = this.interests
          .map(item => item.value)
          .filter(id => id !== NOT_DEFINED_ID)
        const selectedReal = (this.interests_value || []).filter(id => id !== NOT_DEFINED_ID)
        if (selectedReal.length === realInterests.length) {
          this.interests_value = [23]
        } else {
          this.interests_value = realInterests
        }
      })
    },
    ProductChanger (value) {
      if (this.product_value) {
        this.product_is_empty = false
        this.interests_value = [23]
        if (this.product_value == this.product_video_network_web_id) {
          this.platform_values = ["app", "web"]
          this.platform_is_empty = false
        }
        if (this.product_value == this.product_smart_tv_id || this.product_value == this.product_smart_trp_id || this.product_value == this.product_videonetwork_smart_tv_id) {
          this.platform_values = ["smart_tv"]
          this.platform_is_empty = false
        }
        if (this.product_value == this.product_smart_tv_id) {
          this.is_choose_disabled = true;
          this.is_ages_available = true;
          this.age_value = [15];
          this.age_value_range = [0, 6];
          this.sex_value = 3;
        } else {
          this.is_choose_disabled = false;
        }
        if (this.product_value === this.product_online_tv_id || this.product_value === this.product_cinema_online_id) {
          this.DetermineOnlineTvPlatforms();
        }
        if (this.product_value === this.product_flex_id || this.product_value === this.product_flex_sheet_id) {
          this.DetermineFlexPlatforms();
        }
        if (this.product_value == this.product_banner_id) {
          this.platform_values = ["app", "web", "smart_tv"]
          this.platform_is_empty = false
          this.frequency_period_value = "month"
          this.max_frequency = 6
          this.slider = null
          if (this.frequency > 6) { this.frequency = 6 }
          } else if (this.product_value == this.product_banner_premium_id) {
          this.platform_values = ["web"]
          this.platform_is_empty = false
          this.frequency_period_value = "month"
          this.max_frequency = 6
          this.slider = null
        if (this.frequency > 6) { this.frequency = 6 }
          } else if (this.product_value == this.product_banner_reach_fullscreen_id) {
          this.platform_values = ["app"]
          this.platform_is_empty = false
          this.frequency_period_value = "month"
          this.max_frequency = 6
          this.slider = null
        if (this.frequency > 6) { this.frequency = 6 }
        } else {
          this.max_frequency = 10
          if (!this.slider) {
            this.slider = 7
          }
        }
        // if (this.product_value_old == this.product_banner_id || this.product_value == this.product_banner_id) {
        //   this.age_value = [15];
        // }
        if (this.product_value_old == this.product_smart_trp_id && this.product_value != this.product_smart_trp_id) {
          this.age_value = [15];
          this.age_value_range = [0, 6];
        }
        if (this.product_value_old != this.product_smart_trp_id && this.product_value == this.product_smart_trp_id) {
          this.age_value = [15];
          this.age_value_trp_range = [0, 7];
        }
        if (this.product_value === this.product_flex_id && !this.is_not_govnosites) {
          this.$emit('product_changer', this.product_flex_sheet_id)
        } else {
          this.$emit('product_changer', this.product_value)
        }
      }
      this.product_value_old = value
    },
    GovnositesChanger () {
      if (this.product_value === this.product_flex_id && !this.is_not_govnosites) {
        this.$emit('product_changer', this.product_flex_sheet_id)
      } else if (this.product_value === this.product_flex_id && this.is_not_govnosites) {
        this.$emit('product_changer', this.product_flex_id)
      }
    },
    PlatformChanger () {  
      if (this.product_value === this.product_online_tv_id || this.product_value === this.product_cinema_online_id) {
        this.DetermineOnlineTvPlatforms();
      }
      if (this.product_value === this.product_flex_id || this.product_value === this.product_flex_sheet_id) {
        this.DetermineFlexPlatforms();
      }
      if (this.isPlatformValues()) {
        this.platform_is_empty = false
      }
    },
    DetermineFlexPlatforms () {
      if (this.product_value === this.product_flex_id || this.product_value === this.product_flex_sheet_id) {
        // if (this.platform_values.length === 1 && this.platform_values[0] === 'smart_tv') {
        //   this.is_choose_disabled = true;
        //   this.is_ages_available = true;
        //   this.age_value = [15];
        //   this.age_value_range = [0, 6];
        //   this.sex_value = 3;
        // } else {
        //   this.is_choose_disabled = false;
        // }
        if (!this.platform_values) {
          this.platforms[2].disabled = true;
          return
        }
        if (this.platform_values.length === 0) {
          this.platforms[2].disabled = true;
          return
        }
        if (this.platform_values.length === 1 && this.platform_values[0] === 'smart_tv') {
          this.platforms[2].disabled = true;
          this.platform_values = null;
          return
        }
        if (this.platform_values.length > 0) {
          this.platforms[2].disabled = false;
        }
      }
    },
    DetermineOnlineTvPlatforms () {
      if (!this.platform_values) {
        this.platforms_online_tv[2].disabled = true;
        return
      }
      if (this.platform_values.length === 0) {
        this.platforms_online_tv[2].disabled = true;
        return
      }
      if (this.platform_values.length === 1 && this.platform_values[0] === 'web') {
        this.platforms_online_tv[2].disabled = true;
        this.platform_values = null;
        return
      }
      if (this.platform_values.length > 0) {
        this.platforms_online_tv[2].disabled = false;
      }
    },
    FrequencyTrpLimiter () {
      if (this.frequency_period_value == "day") {
        this.min_frequency_trp = 1;
      } else if (this.frequency_period_value == "week") {
        if (this.sex_value == 3) {
          this.min_frequency_trp = 4;
          if (this.frequency_trp < 4) {
            this.frequency_trp = 4;
          }
        } else if (this.sex_value == 2 || this.sex_value == 1) {
          this.min_frequency_trp = 6;
          if (this.frequency_trp < 6) {
            this.frequency_trp = 6;
          }
        }
      }
    },
    PeriodChanger () {
      if (this.frequency_period_value) {
        this.period_is_empty = false;
        this.FrequencyTrpLimiter();
      }
    },
    AgeChanger () {
      if (this.age_value) {
        this.age_is_empty = false
        if (this.age_value.length > this.age_value_old.length) {
          let last_added = this.age_value[this.age_value.length - 1]
          if (last_added == 15) {
            // Без настройки
            this.age_value = [15]
          } else {
            for (let i=0; i<this.age_value.length; i++) {
              if (this.age_value[i] == 15) {
                this.age_value.splice(i, 1)
                break
              }
            }
          }
        }
        this.age_value_old = this.age_value
      }
    },
    AgeSwitchChanger () {
      if (!this.is_ages_available) {
        this.age_value_range = [0, 6]
        this.age_value = [67]
      } else {
        this.age_value = [15]
      }
    },
    AgeRangeChanger () {
      if (this.is_ages_available) {
        if (this.age_value_range[0] == this.age_value_range[1]) {
          if (this.age_value_range[1] < 6) {
            this.age_value_range = [this.age_value_range[0], this.age_value_range[1] + 1];
          } else {
            this.age_value_range = [this.age_value_range[0], this.age_value_range[1] - 1];
          }
        }
        if (this.age_value_range[0] === 0 && this.age_value_range[1] === 6) {
          this.age_value = [15];
        } else {
          let start = this.age_value_range[0] + 1;
          let end = this.age_value_range[1];
          let arr = [];
          while (start <= end) {
            arr.push(start);
            start += 1;
          }
          this.age_value = arr;
        }
      }
    },
    AgeSwitchTrpChanger () {
      if (!this.is_ages_trp_available) {
        this.age_value_trp_range = [0, 7]
        this.age_value = [15]
      } else {
        this.age_value = [15]
      }
      this.determainerCustomerAudience();
    },
    AgeRangeTrpChanger () {
      if (this.is_ages_trp_available) {
        if (this.age_value_trp_range[0] == this.age_value_trp_range[1]) {
          if (this.age_value_trp_range[1] < 7) {
            this.age_value_trp_range = [this.age_value_trp_range[0], this.age_value_trp_range[1] + 1];
          } else {
            this.age_value_trp_range = [this.age_value_trp_range[0] - 1, this.age_value_trp_range[1]];
          }
        }
        if (this.age_value_trp_range[1] - this.age_value_trp_range[0] === 1) {
          if (this.age_value_trp_range[1] < 7) {
            this.age_value_trp_range = [this.age_value_trp_range[0], this.age_value_trp_range[1] + 1];
          } else {
            this.age_value_trp_range = [this.age_value_trp_range[0] - 1, this.age_value_trp_range[1]];
          }
        }
        if (this.age_value_trp_range[0] === 0 && this.age_value_trp_range[1] === 7) {
          this.age_value = [15];
        } else {
          let start = this.age_value_trp_range[0] + 1;
          let end = this.age_value_trp_range[1];
          let arr = [];
          while (start <= end) {
            arr.push(start);
            start += 1;
          }
          this.age_value = arr;
        }
      }
      this.determainerCustomerAudience();
    },
    SexChanger () {
      if (this.sex_value) {
        this.sex_is_empty = false;
        this.FrequencyTrpLimiter();
        this.determainerCustomerAudience();
      }
    },
    AccumChanger () {
      if (this.is_accumulated !== null) {
        this.accum_is_empty = false
      }
    },
    InterestsChanger () {
      const NOT_DEFINED_ID = 23
      if (!this.interests_value || this.interests_value.length === 0) {
        this.interests_value = [NOT_DEFINED_ID]
        this.interests_is_empty = false
        return
        }
        this.interests_is_empty = false
        const lastAdded = this.interests_value[this.interests_value.length - 1]
        if (lastAdded === NOT_DEFINED_ID) {
          this.interests_value = [NOT_DEFINED_ID]
        } else if (this.interests_value.includes(NOT_DEFINED_ID)) {
          this.interests_value = this.interests_value.filter(id => id !== NOT_DEFINED_ID)
        }
    },
    FakeSender () {
      if (!this.product_value) {
        this.product_is_empty = true
      } else if (this.product_value === this.product_smart_trp_id) {
        if (this.frequency_period_value === "month") {
          this.period_is_empty = true
        }
      }
      if (!this.isPlatformValues()) {
        this.platform_is_empty = true
      }
      if (!this.frequency_period_value) {
        this.period_is_empty = true
      }
      if (!this.sex_value) {
        this.sex_is_empty = true
      }
      if (!this.age_value) {
        this.age_is_empty = true
      }
      if (this.is_accumulated === null) {
        this.accum_is_empty = true
      }
      if (!this.interests_value || this.interests_value.length === 0) {
        this.interests_is_empty = true
      }
      if (!this.slider) {
        this.rk_length_is_empty = true
      }
    },
    ChangeRK () {
      if (this.slider > 31) {
        this.slider = 31;
      } else if (this.slider < 1) {
        this.slider = 1;
      }
      if (this.slider < 7) {
        this.frequency_period = [...this.frequency_period_day];
        this.frequency_period_smart_tv = [...this.frequency_period_day];
      } else if (this.slider < 30) {
        this.frequency_period = [...this.frequency_period_day_week];
        this.frequency_period_smart_tv = [...this.frequency_period_day_week];
      } else {
        this.frequency_period = [...this.frequency_period_day_week_month];
      }
      if (!this.frequency_period.map(item => item.value).includes(this.frequency_period_value)) {
        this.frequency_period_value = this.frequency_period[this.frequency_period.length - 1].value;
      }
      this.rk_length_is_empty = false
    },
    ChangeFrequency () {
      if (this.frequency > 10) {
        this.frequency = 10
      } else if (this.frequency < 1) {
        this.frequency = 1
      }
      this.frequency = parseInt(this.frequency, 10)
    },
    ChangeFrequencyTrp () {
      if (this.frequency_trp > this.max_frequency_trp) {
        this.frequency_trp = this.max_frequency_trp;
      } else if (this.frequency_trp < this.min_frequency_trp) {
        this.frequency_trp = this.min_frequency_trp;
      }
      this.frequency_trp = parseInt(this.frequency_trp, 10);
    },
    checkIfNeedNotification (data) {
      if (data["impressions"] > data["limit_impressions"]) {
        return true;
      }
      for (let i=0; i<data["regions"].length; i++) {
        if (data["regions"][i]["impressions"] > data["regions"][i]["limit_impressions"]) {
          return true
        }
      }
    },
    showNotification (data) {
      if (this.checkIfNeedNotification(data)) {
        this.$refs.notify.showNotification('inventory_notify');
      }
    },
    showNotificationMonth (product) {
      if (product == 1 || product == 11 || product == 3 || product == 6 || product == 8) {
        this.$refs.notify_month.showNotification('month_notify');
      }
    },
    async sendCalculateRequest () {
      console.log(!!this.platform_values);
      let age_value = this.age_value
      if (typeof age_value == "number") {
        age_value = [age_value]
      }
      let product = this.product_value
      this.shown_product = this.product_value
      if (this.product_value == this.product_flex_id) {
        if (!this.is_not_govnosites) {
          product = this.product_flex_sheet_id
          this.shown_product = this.product_flex_sheet_id
        }
      }
      let frequency = this.frequency;
      if (this.product_value == this.product_smart_trp_id) {
        frequency = this.frequency_trp;
      }
      let request_obj = {
        "product": product,
        "period": this.slider,
        "device": this.detectDevicesCombination(),
        "frequency": frequency,
        "frequency_period": this.frequency_period_value,
        "age": age_value,
        "sex": this.sex_value,
        "is_accumulated": this.is_accumulated,
        "interests": this.interests_value,
        "date_month": this.date_month_value,
      }
      let token = this.getTokenFromCookies()
      let prod_stat = this.products_list_by_id[product - 1];
      let role_stat = this.user_roles_mapper(this.$cookies.get("user_role_id"));
      // let hashstring = `#product=${prod_stat}&role=${role_stat}`
      let statstring = `${role_stat}__${prod_stat}`
      if (typeof ym === 'function') {
        ym(110360494, 'reachGoal', 'calculate', {
          role: role_stat,
          product: prod_stat,
          role_product: statstring
        });
      } else {
        console.warn('Yandex Metrika is not loaded');
      }
      // history.pushState(null, '', hashstring);
      let data = await sendCalculateRequest(request_obj, token, this)
      this.showNotification(data)
      this.showNotificationMonth(product)
      this.limit_impressions = data["limit_impressions"]
      this.impressions = data["impressions"]
      this.reach = data["reaches"]
      this.regions = data["regions"]
      this.impressions_ratio = data["impressions_ratio"]
      this.raw_data = data["raw_data"]
      this.actual_age_value = this.age_value
      this.type_of_data = "unsmooth"
      this.$emit(
        'popping_up', 
        this.reach,
        this.type_of_data,
        this.impressions_ratio,
        this.limit_impressions,
        this.impressions,
        this.regions,
        this.raw_data,
        this.frequency,
        this.frequency_period,
        this.frequency_period_banner,
        this.frequency_period_value,
        this.shown_product,
        this.slider
      )
    },
    async sendXlsxRequest () {
      let product = this.product_value;
      if (this.product_value == this.product_flex_id) {
        if (!this.is_not_govnosites) {
          product = this.product_flex_sheet_id
        }
      }
      let frequency = this.frequency;
      if (this.product_value == this.product_smart_trp_id) {
        frequency = this.frequency_trp;
      }
      let age_value = this.age_value
      if (typeof age_value == "number") {
        age_value = [age_value]
      }
      let request_obj = {
        "product": product,
        "period": this.slider,
        "device": this.detectDevicesCombination(),
        "frequency": frequency,
        "frequency_period": this.frequency_period_value,
        "age": age_value,
        "sex": this.sex_value,
        "is_accumulated": this.is_accumulated,
        "interests": this.interests_value,
        "date_month": this.date_month_value,
      }
      let token = this.getTokenFromCookies()
      await sendXlsxRequest(request_obj, token, this)
    },
    detectDevicesCombination () {
      for (let index in this.platforms_list) {
        if (isArrayEqual(this.platform_values.sort(), this.platforms_list[index])) {
          return this.platforms_mapper[this.platforms_list[index].join("_")]
        }
      }
    },
    determainerCustomerAudience () {
      if (this.sex_value) {
        let sex_val_str = this.sex_value.toString();
        if (this.sex_value == 3) {
          if (this.age_value_trp_range[0] >= 3) {
            this.customer_audience = this.customer_audiences[sex_val_str][0];
            return;
          } else if (this.age_value_trp_range[0] <= 4 && this.age_value_trp_range[1] <= 4) {
            this.customer_audience = this.customer_audiences[sex_val_str][1];
            return;
          } else if (this.age_value_trp_range[1] < 7 && this.age_value_trp_range[0] > 0) {
            this.customer_audience = this.customer_audiences[sex_val_str][2];
            return;
          }
        } else if (this.sex_value == 1 && this.age_value_trp_range[1] < 7 && this.age_value_trp_range[0] > 0) {
          this.customer_audience = this.customer_audiences[sex_val_str][0];
          return;
        } else if (this.sex_value == 2 && this.age_value_trp_range[1] < 7 && this.age_value_trp_range[0] > 0) {
          this.customer_audience = this.customer_audiences[sex_val_str][0];
          return;
        }
      }
      this.customer_audience = null;
    }
  }
}
</script>

<style lang="sass">

.standart_label
  display: block
  width: 100%
  text-align: left
  color: #242424
  font-size: 14px
  margin-bottom: 4px

.standart_input
  border-radius: 6px !important
  margin-bottom: 5px !important
  overflow: hidden
  .v-input__slot
    min-height: 32px !important
  label
    color: #D4D4D4 !important
    top: 7px !important
    font-size: 14px !important
  .v-input__append-inner
    margin-top: 4px !important
  .v-text-field__details
    display: none !important
  .v-chip
    border-radius: 4px !important
    font-size: 12px !important
    height: 22px !important
    margin: 0 2px 0 2px !important
    padding: 0 6px !important
  &:hover
    fieldset
      border-color: #165FA8 !important
  .v-input--is-focused
    fieldset
      border: 2px solid #165FA8 !important
  .v-select__selections
    flex-wrap: nowrap !important
.readonly_input
  input
    color: #A0A0A0 !important
    cursor: default !important
  .v-input__slot
    background-color: #F2F2F2 !important
    cursor: default !important

.v-list
  padding: 4px 0
  .v-list-item__action
    margin: 0px 0 !important

  .v-list-item__content
    padding: 5px 0 !important
  .v-list-item
    padding: 0 7px !important
    .v-list-item__content
      padding-left: 4px !important
  .v-icon.v-icon
    font-size: 22px !important

.v-list-item--dense, .v-list--dense .v-list-item
  min-height: 34px !important
.v-input__slot
  padding: 0 7px !important

.v-list-item
  &::before
    opacity: 0 !important

  &:hover
    &::before
      opacity: 0 !important

  &.v-list-item--link:hover
    background-color: transparent !important

.button
  width: 100%
  min-height: 34px
  border-radius: 4px
  display: flex
  flex-wrap: nowrap
  align-items: center
  justify-content: center
  background-color: #5585C1
  cursor: pointer
  .icon
    width: 14px
    margin-top: 0 !important
    padding: 0
    margin-right: 5px
    margin-left: -10px
    cursor: pointer
    position: relative
    z-index: 1
  .text
    font-size: 14px
    display: inline-block
    height: 18px
    line-height: 18px
    position: relative
    z-index: 1
    cursor: pointer

#calculate_button_unactive
  background-color: #5585C1
  cursor: default
  .text
    color: #fff !important
    cursor: default
  .icon
    cursor: default

#calculate_button
  background-color: #5585C1
  overflow: hidden
  position: relative
  transition: all 0.5s ease-in-out
  .text
    color: #fff !important
  &:hover::before
    left: 0
  &::before
    content: ""
    position: absolute
    top: 0
    left: -150%
    width: 200%
    height: 100%
    background: linear-gradient(135deg, #466fa3, #6196cf, #5585C1)
    transition: all 0.5s ease-in-out
    z-index: 0

#print_button
  box-sizing: border-box
  border: 1px solid #5585C1
  background-color: #F6F7F9
  .text
    color: #5585C1

.hideble_part
  width: 100%
  height: 0px
  overflow: hidden
  opacity: 0
  transition: all 0.4s ease-in-out
.govnosite_checkbox
  margin-left: -9px !important
  .v-label
    font-size: 14px !important
    color: #242424 !important
  .v-input__slot
    margin-bottom: 0 !important

.hideble_part.open_115
  height: 115px
  opacity: 1

.hideble_part.open_70
  height: 70px
  opacity: 1

.addition_data
  text-align: left
  cursor: pointer
  padding-top: 5px
  padding-bottom: 3px
  span
    color: #165FA8
    display: inline-block
    border-bottom: 1px dashed #165FA8
    line-height: 15px
  &:hover
    span
      border-bottom: 1px dashed transparent
    
.v-slider__ticks-container
  .v-slider__tick:last-child
    .v-slider__tick-label
      position: relative
      left: -6px

.range_slider_wrapper
  position: relative
  text-align: left
  .v-range-slider_inwrap
    width: 256px
    position: relative
    margin-top: 2px
    left: -8px
  .v-switch
    position: absolute
    right: -13px
    top: 0
    margin-top: 0
    padding-top: 0

.customer_audience
  text-align: center

.icon_hint
  position: absolute
  top: 0px
  right: 0

.interests_actions
  display: flex
  justify-content: flex-end
  align-items: center
  gap: 16px
  padding: 8px 12px
  background: #fff
  position: sticky
  bottom: 0

.interests_btn
  min-width: auto !important
  height: auto !important
  padding: 0 !important
  border-radius: 0 !important
  color: #5A5A5A !important

  font-size: 14px !important
  font-weight: 500 !important
  letter-spacing: normal !important
  text-transform: none !important

  transition: color .15s ease

  &::before
    opacity: 0 !important

.interests_btn_ok
  color: #165FA8 !important

.bottom_notifications_wrap
  width: 320px
  min-height: 30px
  position: fixed
  bottom: 10px
  right: 10px

</style>
